module.exports = __webpack_public_path__ + "img/flow_icon05.d845a199.png";